var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningHos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.5V20M18 24.5H18.015M4.5 18.5C4.5 20.2728 4.84919 22.0283 5.52763 23.6662C6.20606 25.3041 7.20047 26.7923 8.45406 28.0459C9.70765 29.2995 11.1959 30.2939 12.8338 30.9724C14.4717 31.6508 16.2272 32 18 32C19.7728 32 21.5283 31.6508 23.1662 30.9724C24.8041 30.2939 26.2923 29.2995 27.5459 28.0459C28.7995 26.7923 29.7939 25.3041 30.4724 23.6662C31.1508 22.0283 31.5 20.2728 31.5 18.5C31.5 14.9196 30.0777 11.4858 27.5459 8.95406C25.0142 6.42232 21.5804 5 18 5C14.4196 5 10.9858 6.42232 8.45406 8.95406C5.92232 11.4858 4.5 14.9196 4.5 18.5Z",
    stroke: "#FF0000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningHos);
export default __webpack_public_path__ + "static/media/warning-hos.577a8fecfa58fbef5f5e0614778c2f47.svg";
export { ForwardRef as ReactComponent };